import type { AppRequestRoute } from '@shared/config'

import { useCustomerStore } from '@entities/customer'
import { runApiWrite } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'

const runCustomerAction = (route: AppRequestRoute, customerId: number): Promise<boolean> => {
  const customerStore = useCustomerStore()

  return runApiWrite(useAdminRoutes(route, { customer_id: customerId }), {
    setLoading: customerStore.trackProcessing,
  })
}

/** `POST …/crm-pull` — overwrites the customer from the Zoho lead; refetch afterwards. */
export const useCustomerCrmPullApi = (customerId: number): Promise<boolean> =>
  runCustomerAction('admin.customer.crm-pull', customerId)

/** `POST …/crm-push` — creates or updates the Zoho lead; refused for DRAFT customers. */
export const useCustomerCrmPushApi = (customerId: number): Promise<boolean> =>
  runCustomerAction('admin.customer.crm-push', customerId)

/** `POST …/send-reload` — tells the customer's open browsers to reload; writes nothing. */
export const useCustomerSendReloadApi = (customerId: number): Promise<boolean> =>
  runCustomerAction('admin.customer.send-reload', customerId)
